import angular from 'angular';
import routes from './header.routes';

import {Header} from './header.component';

import './header.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.layout.header', [])
  .component('headerComponent', Header)
  .config(routes)
  .name;
